
























import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
// import {ImageGallery} from "../../../shared/image-gallery";

@Component({
  name: 'catalog-product-media',
  components: {
    Swiper,
    SwiperSlide,
    ...ServiceContainer().getComponents()
  }
})

export default class extends Vue {
  $refs!: {
    gallerySlider: InstanceType<typeof Swiper>;
    gallerySliderThumbs: InstanceType<typeof Swiper>;
  }

  @Prop() readonly productData: object;
  // private gallery: ImageGallery;
  private addVideo: boolean = true;
  private activeSlide: number = 0;
  private isZoomed: boolean = false;
  private activeMediaGallery: Array<object> = [];

  private get sliderDirection(): string {
    return window.outerWidth < 768 ? 'horizontal' : 'vertical';
  }

  private slideOptions: object = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    direction: this.sliderDirection,
    slidesPerView: 'auto',
    touchRatio: 1,
    watchSlidesVisibility: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.catalog__product_media-gallery_gallery .swiper-button-next',
      prevEl: '.catalog__product_media-gallery_gallery .swiper-button-prev'
    }
  };

  private get productMediaGallery(): Array<object> {
    return this.productData.hasOwnProperty('image_gallery') ? JSON.parse(this.productData['image_gallery']) : {};
  }

  private checkVideo(url, pos): object {
    const type = (url.indexOf('youtu') > -1) ? 'youtube' : 'vimeo';
    let id = null;

    if (type == 'youtube') {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      id = match[7];
    } else {
      const regExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
      const match = url.match(regExp);
      id = match[1];
    }

    return {
      position: pos,
      type: 'video',
      typeVideo: type,
      video: id
    };
  }

  // private zoomImage(): void {
  //   this.$refs.gallerySlider.$swiper.zoom.toggle();
  // }

  private zoomImage(pos): void {
    this.isZoomed = true;
    this.activeSlide = pos;
    document.body.classList.add('no-scroll');
    if (this.productMediaGallery.length > 1) {
      this.$eventBus.$emit('slide-event', this.$refs['gallerySlider'].$swiper.activeIndex);
    }
  }

  private slideToImage(index): void {
    this.$refs.gallerySlider.$swiper.slideTo(index, 600, false);
    this.activeSlide = index;
  }

  private setActiveThumb(): void {
    this.activeSlide = this.$refs.gallerySlider.$swiper.activeIndex;
    this.$refs.gallerySliderThumbs.$swiper.slideTo(this.$refs.gallerySlider.$swiper.activeIndex, 600, false);
  }

  private slideToIndex(index): void {
    this.$refs.gallerySlider.$swiper.slideTo(index, 200, false);
  }

  private created(): void {
    this.activeMediaGallery = this.productMediaGallery;
    this.$eventBus.$on('slideToIndex', index => {
      this.slideToIndex(index);
    });
  }
}
